import React, { useState } from "react";
import { api } from "../../../api/datasource";

const Documento = () => {
  const [url, setUrl] = useState("");
  const [pValue, setPValue] = useState("");

  const extractPValue = (url) => {
    const match = url.match(/p=([^|]+)/);
    return match ? match[1] : "";
  };

  const handleInputChange = (e) => {
    const newUrl = e.target.value;
    setUrl(newUrl);
    setPValue(extractPValue(newUrl));
  };

  const fetchProdutos = async () => {
    if (!pValue) {
      alert("URL inválida. Certifique-se de que contém um parâmetro 'p'.");
      return;
    }

    try {
      const response = await api.get(`/itens_documento?p=${encodeURIComponent(pValue)}`);
      // console.log("Produtos:", response.data);
    } catch (error) {
      console.error("Erro ao obter produtos:", error);
    }
  };

  return (
    <div>
      <input 
        type="text" 
        value={url} 
        onChange={handleInputChange} 
        placeholder="Insira a URL do documento"
        style={{ width: "60%" }}
      />
      <button onClick={fetchProdutos} style={{ marginLeft: "10px" }}>
        Obter Produtos
      </button>
    </div>
  );
};

export default Documento;
